import { useState, useEffect } from 'react';

export const useElementInView = (id: string, options = {}) => {
  const [isInView, setIsInView] = useState(false);
  const [hasBeenInView, setHasBeenInView] = useState(false);

  useEffect(() => {
    const element = document.getElementById(id);

    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);

        if (entry.isIntersecting) {
          setHasBeenInView(true);
        }
      },
      {
        threshold: 0.4,
        ...options,
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [id, options]);

  return hasBeenInView;
};
